export default __webpack_public_path__ + "static/media/landingPost.b92b17af.png";